module.exports = __webpack_public_path__ + "static/media/vf_wwallet_core.ec160946.svg";